import React from 'react';
import './CommonContainerStyles.css';
import Tabs from "../../Components/Tabs/Tabs"
import ConfirmButton from "../../Components/Buttons/ConfirmButton"

function TeacherInformationContainerByAdmin(props) {
	const { header, tabs, handleSubmit } = props;
	return (
		<div className="">
			{tabs ? <Tabs tabs={tabs} /> : null}
			<form>
				<div className="container px-0">
					{props.children}
				</div>
			</form>
			<ConfirmButton type="submit" onClick={handleSubmit}>
				Submit
			</ConfirmButton>
		</div>
	)
}

export default TeacherInformationContainerByAdmin;